module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAUCAYAAABmvqYOAAAANElEQVRIS2P8////fwYaAcahaziNQgRsLOOo4dhCYAgHy9BN5zR1+Wg6H03nRKeBoVtZAACeniPxQhDAOgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone/menu.png
// module id = KJYY
// module chunks = 9